export default {
  home: {
    title: "Messages sortants",
  },
  empty: "Aucun message dans la file",
  refresh: "Actualiser la file",
  filters: {
    allStatuses: "Tous les statuts",
    eventType: "Type d'événement…",
    tenant: "ID du tenant…",
  },
  status: {
    pending: "En attente",
    sent: "Envoyé",
    failed: "Échec",
    dead: "Abandonné",
  },
  fields: {
    status: "Statut",
    eventType: "Type d'événement",
    targetUrl: "URL cible",
    attempts: "Tentatives",
    lastError: "Dernière erreur",
    tenant: "Tenant",
    created: "Créé le",
    nextRetry: "Prochaine tentative",
  },
  actions: {
    retry: {
      label: "Réessayer",
      success: "Nouvelle tentative déclenchée",
    },
    delete: {
      label: "Supprimer",
      title: "Supprimer le message",
      confirm: "Supprimer « %{name} » ? Cette action est irréversible.",
      success: "Message supprimé",
    },
  },
};
